import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

@Component({
  selector: 'app-client-mismatch-dialog',
  templateUrl: './client-mismatch-dialog.component.html',
  styles: [`
    [modal-body] {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    [modal-body] > label {
      display: block;
      max-width: 32rem;
      margin-inline: auto;
    }

    [modal-actions].lms-action-bar {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      flex-wrap: wrap;
      width: 100%;
    }
  `],
  imports: [CommonModule, LmsModalFrameComponent, MdbRippleModule],
  standalone: true,
})
export class ClientMismatchDialogComponent implements OnInit{

   lmsClientName: string;
   lmsClientSurname: string;
   bureauClientName: string;
   bureauClientSurname: string;
   quoteId: number;
    data: any;

   private quote_apiURL = `${environment.apiUrl}/loan/api/quote`;
   httpOptions = {
    headers: new HttpHeaders({
    'Content-Type': 'application/json'
    })
  };


constructor(
  //public global_utility: AppUtilityService,
  private httpClient: HttpClient,
  public dialogRef: MdbModalRef<ClientMismatchDialogComponent>
  )
{ }

 ngOnInit(): void {
  //  console.log('ClientChangeLogReportComponent initialized');
  //   console.log(this.clientChangeLogList);
  }

  continue() {
    this.dialogRef.close();
    //return this.dialogRef.close(this.employmentDetailsForm.value);
  }

  close() {
    this.dialogRef.close();
    //return this.dialogRef.close(this.employmentDetailsForm.value);
  }

  reject() {
    console.log('asfffaqff');

   // const currQuote: any = {...this.bureauClientName};
   // currQuote.quoteId = this.quoteStoreService.quoteWorkbook.id;
  //  currQuote.userName = this.global_utility.getGlobalData("userDisplay");
    //currQuote.cancelRequest = 'Cancel';

    // quote.setRejectOfferReason(String.valueOf(request.getRejectOfferReason()));
    // quote.setRejectOtherReason(request.getRejectOtherReason());
    // quote.setUpdatedBy(request.getUserName())

      const rejectObject: any = {
      quoteId: this.quoteId,
      rejectOfferReason: this.bureauClientName,
      userName: '',
      cancelRequest: 'Rejected'
      //hasValidAccessToken: jasmine.createSpy('hasValidAccessToken').and.returnValue(false),
      //hasValidIdToken: jasmine.createSpy('hasValidIdToken').and.returnValue(false),
      //initCodeFlow: jasmine.createSpy('initCodeFlow')
    };

    this.rejectOffer(rejectObject);
  }

  rejectOffer(data: any) {
    return this.httpClient.post<any>(`${this.quote_apiURL}/rejectOffer`, data)
      .pipe(
        map((responseData: any) => {
          //this.quoteWorkbook = responseData;
          return responseData;
        })
      );
  }
}
